import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

const Text = (props) => {
  return (
    <Typography
      className={ props.className }
      style={ props.style }
    >
      { props.children }
    </Typography>
  );
};

Text.defaultProps = {
  className: {},
};

Text.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Text;
